import gql from "graphql-tag";

export default gql`
  mutation QueryVeriryEmail($token: String!) {
    verified: verifyEmail(verificationToken: $token) {
      token
    }
  }
`;
